import Icon from '@atoms/Icon/Icon';
import MotionWrapper from '@atoms/MotionWrapper/MotionWrapper';
import classNames from 'classnames';
import type { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';

interface Props
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  readonly open?: boolean;
  readonly loadMoreLabel: string;
  readonly loadLessLabel?: string;
  readonly _type?: 'BASIC' | 'YELLOW-HIGHLIGHT';
  readonly isLightMode?: boolean;
  readonly dataTestId?: string;
}

const LoadMoreButton = ({
  open = false,
  loadMoreLabel,
  loadLessLabel,
  _type = 'BASIC',
  isLightMode,
  dataTestId,
  ...props
}: Props) => (
  <button
    className={classNames(
      'z-10 flex cursor-pointer flex-row items-center justify-center gap-4',
      _type === 'YELLOW-HIGHLIGHT' && open
        ? 'text-yellow underline decoration-1 underline-offset-4'
        : `text-black-100 ${isLightMode ? '' : 'dark:text-white'}`
    )}
    data-testid={dataTestId}
    {...props}
  >
    {(!open || loadLessLabel) && (
      <p className="h6">{open ? loadLessLabel : loadMoreLabel}</p>
    )}

    <MotionWrapper
      tag="span"
      animate={{
        rotate: open ? -180 : 0,
      }}
    >
      <Icon name="down_arrow" size="1.25rem" colorClassName="text-yellow" />
    </MotionWrapper>
  </button>
);

export default LoadMoreButton;
